// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_sd-5";
export var filledCircle = "_sd-4";
export var historyEntry = "_sd-3";
export var messageSideLeft = "_sd-1";
export var messageSideRight = "_sd-2";
export var orderTrackingCarouselWrapper = "_sd-6";
export var orderTrackingInfoContainer = "_sd-0";